<template src="./statoOrdini.html"></template>

<script>
import { get_statoOrdini, get_dettaglioOrdini } from "@/api/api.ordini.js";
import tabella from "@/components/ui/Table.vue";
import DialogPdf from "@/components/dialog/ordini/PdfConferma.vue";

export default {
  components: {
    tabella,
    DialogPdf,
  },

  data: function () {
    return {
      dati: [],
      headers: [
        { text: "Ordine", align: "center", value: "NUM_ORD", sortable: "true" },
        {
          text: "Data Conferma",
          align: "center",
          value: "Data_ord",
          sortable: "true",
        },
        {
          text: "Consegna prevista",
          align: "center",
          value: "DataConsegna",
          sortable: "true",
        },
        {
          text: "Rag.Sociale",
          align: "left",
          value: "CLRAGSOC",
          sortable: "true",
        },
        { text: "Consegna", align: "center", value: "", sortable: "true" },
        { text: "", align: "center", value: "StatoPerc" },
      ],

      search: "",
      pagination: {
        rowsPerPage: 300,
        //sortBy: "NUM_ORD"
      },

      switchConsegna: true,
      attesaDettaglio: false,

      selectedRow: {},

      datiDettaglio: [],

      dialogPdf: false,
      progDoc: 0,
      codCliente: "",

      ordDesc: true,
      ordColumn: "NUM_ORD",
    };
  },

  methods: {
    async caricaDati() {
      // Reset
      this.dati = [];
      this.datiDettaglio = [];

      let par = "";
      let userSwitch = this.$store.getters["user/getUserSwitch"];
      if (userSwitch.Codice) par = userSwitch.Tipo + "/" + userSwitch.Codice;
      par += "?consegnati=" + !this.switchConsegna;

      let res = await get_statoOrdini(par);
      this.dati = res.data;
    },

    getColorePerc(valore) {
      if (valore == 100) return "green accent-4";
      else if (valore >= 90) return "light-blue accent-4";
      else if (valore >= 80) return "light-blue accent-3";
      else if (valore >= 60) return "light-blue accent-2";
      else if (valore >= 40) return "orange darken-1";
      else if (valore >= 20) return "amber darken-1";
      else return "grey lighten-1";
    },

    //#region ordinamento tabella
    async changeSort(column) {
      if (column != this.ordColumn) {
        this.ordColumn = column;
        this.ordDesc = true;
      } else {
        this.ordDesc = !this.ordDesc;
      }

      let thisP = this;
      switch (column) {
        case "Data_ord":
          this.dati = await this.ordinaDate(this.dati);
          break;
        case "NUM_ORD":
          this.dati.sort(function (a, b) {
            return thisP.ordinaValori(a.NUM_ORD, b.NUM_ORD);
          });
          break;
        case "CLRAGSOC":
          this.dati.sort(function (a, b) {
            return thisP.ordinaValori(a.CLRAGSOC, b.CLRAGSOC);
          });
          break;
        case "Num_conferma":
          this.dati.sort(function (a, b) {
            return thisP.ordinaValori(a.Num_conferma, b.Num_conferma);
          });
          break;
        case "Scadenza":
          this.dati.sort(function (a, b) {
            return thisP.ordinaValori(a.Scadenza, b.Scadenza);
          });
          break;
        case "ConfermaWeb":
          this.dati.sort(function (a, b) {
            return thisP.ordinaValori(a.ConfermaWeb, b.ConfermaWeb);
          });
          break;
        case "StatoPerc":
          this.dati.sort(function (a, b) {
            return thisP.ordinaValori(a.StatoPerc, b.StatoPerc);
          });
          break;
      }
    },

    ordinaValori(a, b) {
      if (this.ordDesc) return a > b ? -1 : a < b ? 1 : 0;
      else return a < b ? -1 : a > b ? 1 : 0;
    },

    async ordinaDate(arr) {
      let thiss = this;
      await arr.sort(function (a, b) {
        a = new Date(thiss.$i2kFunctions.formatITDateToISO(a.Data_ord));
        b = new Date(thiss.$i2kFunctions.formatITDateToISO(b.Data_ord));
        return thiss.ordinaValori(a, b);
      });
      return arr;
    },

    //mi serve una funzione di ordinamento personalizzato che ritorni i dati della tabella altrimenti prende l'ordinamento automatico
    customSort(items, index, isDesc) {
      return items;
    },
    //#endregion

    visDettaglio(props) {
      // Reset
      this.selectedRow = [];

      // Gestione apertura pannello
      props.expanded = !props.expanded;

      if (!props.expanded) return;

      this.selectedRow = props.item;

      // Reset
      this.datiDettaglio = [];

      this.attesaDettaglio = true;

      setTimeout(() => this.caricaDettaglio(props), 500);
    },

    async caricaDettaglio(props) {
      let prog = props.item.Progressivo;

      let res = await get_dettaglioOrdini(prog);
      this.datiDettaglio = res.data;

      this.attesaDettaglio = false;
    },

    apriPdf(item) {
      if (item.Num_conferma == 0) return;
      this.progDoc = item.Num_conferma;
      this.codCliente = item.COD_CLI;
      this.dialogPdf = true;
    },
    chiudiPdf() {
      this.dialogPdf = false;
    },
  },

  async mounted() {
    //aspetto qualche millisecondo cosi vue carica i dati dell'utente nello storage
    await this.$functions.delay(500);
    this.caricaDati();
  },

  computed: {
    userSwitch: function () {
      return this.$store.getters["user/getUserSwitch"];
    },

    getDati() {
      return this.dati;
    },
  },

  watch: {
    userSwitch() {
      this.caricaDati();
    },
  },
};
</script>

<style scoped>
table.v-table thead th {
  color: #6a573e;
  font-size: 12px;
}

table.v-table thead tr {
  background: #e6bc87;
  border-bottom: 0px !important;
}
table.v-table tbody tr:last-child {
  border-bottom: 1px solid #d9d9d9;
}

table.v-table th:nth-child(1) {
  border-radius: 7px 0px 0px 7px;
}
table.v-table th:nth-last-child(1) {
  border-radius: 0px 7px 7px 0px;
}

table.v-table tbody td:not(:last-child) {
  border-right: 1px solid lightgray;
}

table.v-table tbody tr {
  cursor: pointer;
}
</style>